<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <h4 v-if="!propOpenedInModal" class="card-title">{{cvCardTitle}}</h4>
          <form action="#" v-if="vmChatMessageFormData && Object.keys(vmChatMessageFormData).length > 0">
            <div class="form-row">
              <div class="col-md-12 mb-3">
                <vue-editor v-model="vmChatMessageFormData.text_msg"></vue-editor>
              </div>
            </div>
            <div class="form-group">
              <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                <b-spinner label="Spinning"></b-spinner>
              </button>
              <button type="button" class="btn btn-primary" @click="ChatMessageEdit()">{{cvSubmitBtn}}</button>
            </div>
          </form>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { ChatMessages } from "../../../FackApi/api/ChatMessage.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import { VueEditor } from "vue2-editor"

export default {
  name: "ChatMessageEdit",
  components: {
    VueEditor
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propChatMessageObj: {
      type: Object,
      default: function () {
        return {
          "text_msg": ""
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit Chat Message",
      cvSubmitBtn: "Save",
      showToast: false,
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "ChatMessage Updated",
      vmChatMessageFormData: {}
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.ChatMessageView()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmChatMessageFormData) {
          if (!this.vmChatMessageFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * ChatMessageView
     */
    async ChatMessageView () {
      try {
        if (this.propOpenedInModal) {
          this.vmChatMessageFormData = this.propChatMessageObj
        }
        else {
          let ChatMessageId = this.$route.params.chtmsg_id
          let ChatMessageViewResp = await ChatMessages.ChatMessageView(this, ChatMessageId)

          if (ChatMessageViewResp && ChatMessageViewResp.resp_status) {
            this.vmChatMessageFormData = ChatMessageViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at ChatMessageView() and Exception:", err.message)
      }
    },
    /**
     * ChatMessageEdit
     */
    async ChatMessageEdit () {
      try {
        this.cvLoadingStatus = true
        let ChatMessageAddResp = await ChatMessages.ChatMessageEdit(this, this.vmChatMessageFormData)
        await ApiResponse.responseMessageDisplay(this, ChatMessageAddResp)

        if (ChatMessageAddResp && !ChatMessageAddResp.resp_status) {
          return false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseChatMessageEditModal", this.vmChatMessageFormData)
        }
      }
      catch (err) {
        console.error("Exception occurred at ChatMessageEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
<style scoped>
.textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
